var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page",class:{ 'is-a3': _vm.isA3 }},_vm._l((_vm.catalogArr),function(item,index){return _c('catalog',{key:index,attrs:{"idx":index,"catalogArr":item,"isA3":_vm.isA3}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }